const STORAGE_KEY = 'openBankingTabOperation'
const REDIRECT_KEY = 'openBankingRedirectPerformed'

/**
 * Marks the current tab as owner of an Open Banking operation (before POST create).
 *
 * @param {{ walletUuid: string, operationId: string }} params
 */
export function setTabOperation({ walletUuid, operationId }) {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ walletUuid, operationId }),
  )
}

export function clearTabOperation() {
  sessionStorage.removeItem(STORAGE_KEY)
}

/**
 * @returns {{ walletUuid: string, operationId: string } | null}
 */
export function getTabOperation() {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw)
    if (parsed?.walletUuid && parsed?.operationId) {
      return parsed
    }
  } catch {
    return null
  }

  return null
}

/**
 * Whether this tab started the given operation (for WS Start redirect).
 *
 * @param {string} walletId - wallet UUID from WS payload
 * @param {string} operationId - operation UUID from WS payload
 * @returns {boolean}
 */
export function isMyOperation(walletId, operationId) {
  const tab = getTabOperation()
  if (!tab) {
    return false
  }

  return tab.walletUuid === walletId && tab.operationId === operationId
}

/**
 * Marks that the redirect to Yapily has been performed for the given operation.
 * Prevents repeated navigation on duplicate or post-return Start events.
 *
 * @param {string} operationId
 */
export function setRedirectPerformed(operationId) {
  sessionStorage.setItem(REDIRECT_KEY, operationId)
}

/**
 * Whether the redirect to Yapily has already been performed for the given operation.
 *
 * @param {string} operationId
 * @returns {boolean}
 */
export function hasRedirectPerformed(operationId) {
  return sessionStorage.getItem(REDIRECT_KEY) === operationId
}
